export const isMobileDevice = () => {
  if (window.outerWidth < 768) {
    return true;
  }
  return false;
};
